import DashboardConst from '@/constants/dashboard';

export default {
  data() {
    return {
    };
  },
  computed: {
    isDashboardLoading() {
      return this.$store.state.dashboard.isLoading;
    },
    /**
     * 현재 View 모드를 반환한다.
     * @author KangBonghun(toto1323)
     * @return {String} monitoring || edit
     */
    viewMode() {
      return this.$store.getters.getDashboardViewMode;
    },
    /**
     * 현재 편집 모드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isEditMode() {
      return this.viewMode === DashboardConst.VIEW_MODE.EDIT;
    },
    /**
     * 현재 트리 편집 모드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isTreeEditMode() {
      return this.viewMode === DashboardConst.VIEW_MODE.TREE_EDIT;
    },
    /**
     * 현재 모니터링 모드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isMonitoringMode() {
      return this.viewMode === DashboardConst.VIEW_MODE.MONITORING;
    },
    /**
     * 현재 전체화면 모드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isFullScreen() {
      return this.$store.getters.getDashboardFullScreen;
    },
    /**
     * 대시보드 데이터
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    dashboardData() {
      return this.$store.getters.getDashboardData || {};
    },
    /**
     * 위젯 레이아웃 정보
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetLayout() {
      return this.dashboardData.dashboardType === this.dashboardType ? this.dashboardData.layoutInfo || [] : [];
    },
    /**
     * 대시보드 위젯 정보
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    dashboardWidget() {
      return this.dashboardData.dashboardWidget || {};
    },
    /**
     * 대시보드 위젯 템플릿 목록
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetTempl() {
      return this.$store.getters.getWidgetTempl;
    },
    /**
     * 현재 대시보드 아이디
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    currentDashboardId() {
      const dashboard = this.$store.getters.getDashboardData;

      return dashboard ? dashboard.dashboardId : null;
    },
    /**
     * 대시보드 구분 (좌표 / 그리드)
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    dashboardType() {
      return this.$store.getters.getDashboardType;
    },
    /**
     * 그리드 대시보드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isGridDashboard() {
      return this.dashboardType === DashboardConst.DASHBOARD_TYPE.GRID;
    },
    /**
     * 좌표 대시보드 여부
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isCoordDashboard() {
      return !this.isGridDashboard;
    },
    /**
     * 스케일 맞춤 여부
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    isFullScale() {
      return this.$store.getters.getDashboardFullScale;
    },
    /**
     * 반응형 레이아웃 옵션화 여부
     * @author JungJiyoon(ryunnnne)
     * @return {Boolean} [description]
     */
    isResponsive() {
      return this.$store.getters.getResponsiveLayout;
    },
    /**
     * 커스텀대시보드 컨트롤바 표현 여부
     * @author LeejeongHoon(leejh55)
     * @return {Boolean} [description]
     */
    isControlbarVisible() {
      return this.$store.getters.getCoordDashboardControlbar;
    },
    /**
     * 대시보드 테마
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    dashboardTheme: {
      get() {
        return this.$store.getters.getDashboardTheme;
      },
      set(theme) {
        this.$store.commit('setDashboardTheme', theme);
      },
    },
    /**
     * 로테이션 정보
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    currentRotationInfo() {
      return this.$store.getters.getRotationInfo;
    },
    /**
     * 편집 선택 모드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    editSelectMode() {
      return this.$store.getters.getEditSelectMode;
    },
    /**
     * 이벤트 등급 정보
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    eventlevelList() {
      return this.$store.getters.eventlevelList;
    },
    /**
     * 좌측 영역 설정 타입
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    sideSettingType() {
      return this.$store.getters.getSideSettingType;
    },
    /**
     * 로테이션 번호에 따른 위젯 표현 여부 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetVisible() {
      return (layout) => {
        let visible = true;
        try {
          const baseOptions = this.dashboardWidget[layout.i].widgetInfo.baseOptions;

          // 로테이션 타입이 '보이기/숨기기' 인 위젯만 로테이션 번호에 따라 보이거나 숨긴다.
          if (baseOptions.rotationType === DashboardConst.ROTATION.TYPE.VIEW) {
            // 편집 모드에서는 툴바에서 선택하는 로테이션 필터링에 따라 보여지거나 숨겨진다.
            if (this.isEditMode) {
              const rotationIds = this.$store.getters.getEditFilterRotationIds || [];
              visible = rotationIds.indexOf(baseOptions.rotationNumber) > -1;
            } else {
              visible = baseOptions.rotationNumber === this.currentRotationInfo.childNumber;
            }
          }
        } catch (e) {
          console.log(e);
        }
        return visible;
      };
    },
    isSlideshow() {
      return this.$store.getters.getDashboardSlideshow;
    },
  },
  methods: {
    /**
     * 대시보드 로딩 상태 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} loading [description]
     * @return {[type]}         [description]
     */
    showLoading(loading) {
      this.$store.state.dashboard.isLoading = loading;
    },
    /**
     * 로테이션 상태 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} parentNumber [description]
     * @param  {[type]} childNumber  [description]
     */
    setRotation(parentNumber, childNumber) {
      this.$store.commit('setRotationInfo', {
        parentNumber,
        childNumber,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dashboard/base.js